module.exports = __webpack_public_path__ + "/img/dc6e44c26ef675b8025046d4f2818353.png";